var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 434.69,
    height: 339.471,
    viewBox: "0 0 434.69 339.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01f2b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 65.423,
    height: 96.975,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14e2c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00adf4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#4a5160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171f32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.846,
    y1: 0.145,
    x2: 0.42,
    y2: 0.793,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.852,
    y1: 0.244,
    x2: 0.385,
    y2: 1.01,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39564",
    "data-name": "Group 39564",
    transform: "translate(-682 -195.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39563",
    "data-name": "Group 39563",
    transform: "translate(948 195.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39562",
    "data-name": "Group 39562",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80161",
    "data-name": "Path 80161",
    d: "M33.226,0C53.059,0,63.748,11.333,63.748,25.5c0,12.363-7.727,18.931-14.166,21.12v.515c9.4,3.091,15.841,10.3,15.841,22.666,0,15.84-11.333,27.173-31.037,27.173C14.81,96.975.644,87.7,0,66.453H21.378c.129,7.341,4.121,12.235,12.235,12.235,6.826,0,10.56-4.379,10.56-10.561,0-8.371-5.023-11.719-16.484-11.719H23.568v-17.9h4.121c7.47,0,14.681-1.8,14.681-10.3,0-6.31-3.735-9.787-9.659-9.787-7.083,0-9.659,5.151-10.045,10.3H1.159C1.932,10.174,14.038,0,33.226,0",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39542",
    "data-name": "Group 39542",
    transform: "translate(-90 49.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39541",
    "data-name": "Group 39541",
    transform: "translate(772 146.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 434.69,
    height: 0.217,
    transform: "translate(0 300.21)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 28.794,
    height: 0.217,
    transform: "translate(68.281 307.504)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 26.229,
    height: 0.217,
    transform: "translate(115.915 313.772)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 33.254,
    height: 0.217,
    transform: "translate(49.424 315.572)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 13.823,
    height: 0.217,
    transform: "translate(377.311 315.103)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 34.184,
    height: 0.217,
    transform: "translate(340.336 315.103)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 26.368,
    height: 0.217,
    transform: "translate(217.345 307.391)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 62.682,
    height: 0.217,
    transform: "translate(247.487 307.391)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 18.839,
    height: 173.589,
    transform: "translate(359.885 159.708) rotate(45)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79794",
    "data-name": "Path 79794",
    d: "M357.2,301.448,343.881,288.12,325.72,306.281l12.215,19.483Z",
    transform: "translate(-42.545 -69.875)",
    fill: "#484f5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 6.277,
    height: 173.589,
    transform: "translate(254.896 300.21) rotate(-135)",
    fill: "#484f5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 18.839,
    height: 173.589,
    transform: "translate(237.142 177.46) rotate(-45)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 6.277,
    height: 173.589,
    transform: "translate(377.644 282.449) rotate(135)",
    fill: "#484f5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 14.666,
    height: 135.102,
    transform: "translate(142.815 190.86) rotate(45)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79795",
    "data-name": "Path 79795",
    d: "M120.1,319.393,109.727,309.03,95.6,323.166l9.5,15.153Z",
    transform: "translate(-12.487 -72.606)",
    fill: "#484f5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 4.886,
    height: 135.102,
    transform: "translate(61.103 300.212) rotate(-135)",
    fill: "#484f5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 14.666,
    height: 135.102,
    transform: "translate(47.29 204.684) rotate(-45)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 4.886,
    height: 135.102,
    transform: "translate(156.629 286.383) rotate(135)",
    fill: "#484f5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 15.31,
    height: 93.267,
    transform: "translate(261.909 206.934)",
    fill: "#373f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79796",
    "data-name": "Path 79796",
    d: "M316.57,319.69H301.26v11.189l15.31-3.3Z",
    transform: "translate(-39.35 -73.999)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    width: 5.103,
    height: 93.267,
    transform: "translate(282.314 300.21) rotate(180)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 15.31,
    height: 93.267,
    transform: "translate(101.535 206.934)",
    fill: "#373f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79797",
    "data-name": "Path 79797",
    d: "M132.091,319.69h-15.3v11.189l15.3-3.3Z",
    transform: "translate(-15.255 -73.999)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 5.103,
    height: 93.267,
    transform: "translate(121.939 300.21) rotate(180)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 195.393,
    height: 28.707,
    transform: "translate(89.86 220.61)",
    fill: "#373f4f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 2.869,
    height: 28.707,
    transform: "translate(288.122 249.308) rotate(180)",
    fill: "#343841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79798",
    "data-name": "Path 79798",
    d: "M232.932,257.17h-38.2L167.72,284.182v38.2l27.012,27.012h38.2l27.012-27.012v-38.2Z",
    transform: "translate(-21.907 -65.833)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79799",
    "data-name": "Path 79799",
    d: "M231.818,262.02H197.113L172.57,286.563v34.706l24.543,24.543h34.706l24.543-24.543V286.563Z",
    transform: "translate(-22.541 -66.466)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79800",
    "data-name": "Path 79800",
    d: "M182.19,312.371l4.886-.435a6.859,6.859,0,0,0,.643,2.608,2.486,2.486,0,0,0,2.269,1.434,2.052,2.052,0,0,0,1.739-.73,2.742,2.742,0,0,0,.026-3.391,5.651,5.651,0,0,0-2.608-1.374,9.833,9.833,0,0,1-4.816-2.869,6.955,6.955,0,0,1-1.452-4.573,8.172,8.172,0,0,1,.739-3.478,5.782,5.782,0,0,1,2.234-2.547,7.625,7.625,0,0,1,4.086-.93,6.564,6.564,0,0,1,4.86,1.687c1.113,1.122,1.739,2.912,1.991,5.364l-4.842.409a4.469,4.469,0,0,0-.809-2.33,2.147,2.147,0,0,0-1.739-.722,1.678,1.678,0,0,0-1.348.539,1.974,1.974,0,0,0-.452,1.313,1.522,1.522,0,0,0,.374,1.017,3.564,3.564,0,0,0,1.739.869,17.1,17.1,0,0,1,4.825,2.087,6.19,6.19,0,0,1,2.121,2.608,8.859,8.859,0,0,1,.661,3.478,9.859,9.859,0,0,1-.869,4.19,6.59,6.59,0,0,1-2.478,2.921,7.407,7.407,0,0,1-4,.991q-4.234,0-5.868-2.33A11.128,11.128,0,0,1,182.19,312.371Z",
    transform: "translate(-23.798 -70.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79801",
    "data-name": "Path 79801",
    d: "M201.17,296.6h15.649v5.851H211.6v17.814h-5.138V302.451h-5.216Z",
    transform: "translate(-26.277 -70.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79802",
    "data-name": "Path 79802",
    d: "M220.139,308.39q0-5.79,2.269-9.024a7.911,7.911,0,0,1,12.71-.052q2.287,3.173,2.286,8.876a19.787,19.787,0,0,1-.982,6.807,9.146,9.146,0,0,1-2.834,4.13,7.181,7.181,0,0,1-4.616,1.478,7.955,7.955,0,0,1-4.651-1.278,8.824,8.824,0,0,1-2.991-4.034,18.109,18.109,0,0,1-1.191-6.9Zm5.138,0a10.464,10.464,0,0,0,.939,5.147,2.878,2.878,0,0,0,5.1,0c.609-1.026.869-2.86.869-5.5a9.729,9.729,0,0,0-.939-4.886,2.912,2.912,0,0,0-2.608-1.539,2.825,2.825,0,0,0-2.5,1.565,11.8,11.8,0,0,0-.869,5.251Z",
    transform: "translate(-28.754 -70.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79803",
    "data-name": "Path 79803",
    d: "M243.1,296.6h8.537a4.86,4.86,0,0,1,4.182,1.9,8.955,8.955,0,0,1,1.382,5.373,9.137,9.137,0,0,1-1.513,5.6,5.39,5.39,0,0,1-4.616,2.017h-2.852v8.781H243.07Zm5.121,10.093h1.261a2.547,2.547,0,0,0,2.087-.739,2.86,2.86,0,0,0,.6-1.878,3.3,3.3,0,0,0-.469-1.913,2.182,2.182,0,0,0-1.956-.774h-1.521Z",
    transform: "translate(-31.75 -70.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79806",
    "data-name": "Path 79806",
    d: "M234.3,141.594c-1.6-10.615-10.059-18.014-22.43-18.014-10.146,0-20.587,4.964-28.359,12.6h0a11.884,11.884,0,0,0-8.19-2.921c-8.572,0-17.588,6.955-20.117,15.536a15.544,15.544,0,0,0-.635,3.895h0l-.174.113c-7.12,4.842-3.591,16.005,5.016,16.005H231.8a13.684,13.684,0,0,0,13.162-9.615v-.1C247.725,149.966,242.97,142.446,234.3,141.594Z",
    transform: "translate(-19.669 -48.383)",
    fill: "#373f4f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-17",
    transform: "translate(48.781 319.788)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-17",
    cx: 168.564,
    cy: 9.841,
    rx: 168.564,
    ry: 9.841,
    transform: "translate(0 0)",
    fill: "#373f4f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-401--inject-17",
    transform: "translate(74.697 5.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79807",
    "data-name": "Path 79807",
    d: "M122.183,118.166H78.54v-19.7L122.183,46.59h20.865V99.622h10.824V118.21H143.065v16.118H122.2Zm0-18.587V72.445L99.127,99.579Z",
    transform: "translate(-78.54 -46.59)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17",
    transform: "translate(154.733 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79809",
    "data-name": "Path 79809",
    d: "M303.793,171.833c-.383.687-.678,1.182-1.017,1.739s-.678,1.078-1.017,1.617c-.687,1.061-1.417,2.087-2.156,3.112a71.659,71.659,0,0,1-4.79,5.92,56.874,56.874,0,0,1-5.573,5.434,39.834,39.834,0,0,1-6.668,4.677,16.059,16.059,0,0,1-2.339,1.121,14.869,14.869,0,0,1-2.608.73,19.413,19.413,0,0,1-4.808.226,29.732,29.732,0,0,1-8.111-1.878,48.68,48.68,0,0,1-6.955-3.3,50.35,50.35,0,0,1-6.26-4.225,3.043,3.043,0,0,1,2.973-5.216l.156.061a77.111,77.111,0,0,0,12.632,3.834,23.638,23.638,0,0,0,5.781.478,8.2,8.2,0,0,0,2.226-.409,4.345,4.345,0,0,0,.774-.339c.243-.139.287-.183.782-.522a46.3,46.3,0,0,0,8.876-8.563c1.365-1.669,2.7-3.4,3.956-5.216.643-.869,1.252-1.8,1.869-2.7l.869-1.356.817-1.278.139-.217a6.086,6.086,0,0,1,10.433,6.251Z",
    transform: "translate(-187.436 -53.506)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79810",
    "data-name": "Path 79810",
    d: "M255.314,184.8l-6.668-4.416-2.825,8.868a8.407,8.407,0,0,0,8.572-.435Z",
    transform: "translate(-186.842 -55.802)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79811",
    "data-name": "Path 79811",
    d: "M241.915,181.576l-.522,2.825a2.7,2.7,0,0,0,1.061,2.678l2.756,2.034,2.826-8.868-2.678-.782a2.721,2.721,0,0,0-3.443,2.113Z",
    transform: "translate(-186.258 -55.668)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79812",
    "data-name": "Path 79812",
    d: "M309.388,156.929C302.6,158,295.73,165.97,291.6,173.4a26.386,26.386,0,0,0,11.763,10.8s8.05-7.616,11.3-13.249S315.777,155.911,309.388,156.929Z",
    transform: "translate(-192.822 -52.729)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79813",
    "data-name": "Path 79813",
    d: "M309.388,156.929C302.6,158,295.73,165.97,291.6,173.4a26.386,26.386,0,0,0,11.763,10.8s8.05-7.616,11.3-13.249S315.777,155.911,309.388,156.929Z",
    transform: "translate(-192.822 -52.729)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79814",
    "data-name": "Path 79814",
    d: "M291.682,173.93a7.729,7.729,0,0,0-1.452,2.426c1.7,2.608,5.721,9.563,13.232,11.041a3.478,3.478,0,0,0,1.574-1.852S296.394,181.285,291.682,173.93Z",
    transform: "translate(-192.643 -54.96)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79815",
    "data-name": "Path 79815",
    d: "M338.125,156.483a90.867,90.867,0,0,0-24.838-.713,12.706,12.706,0,0,0-10.737,12.684,114.507,114.507,0,0,0,1.739,19.344c-2.269,11.954-3.086,28.2-.7,31.785l42.765.6c1.834-5.112-.469-27.238,1.973-50.337A12.223,12.223,0,0,0,338.125,156.483Z",
    transform: "translate(-194.2 -52.518)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79816",
    "data-name": "Path 79816",
    d: "M324.837,221.536c-2.443-19.239,0-51.415,0-51.746l.869.07c0,.322-2.426,32.411,0,51.563Z",
    transform: "translate(-197.021 -54.419)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79817",
    "data-name": "Path 79817",
    d: "M318.045,156.335c1.469-.548.922-1.365.922-1.365a53.44,53.44,0,0,0-11.3,1.243c-.7.748.052,1.739.052,1.739A34.862,34.862,0,0,0,318.045,156.335Z",
    transform: "translate(-194.881 -52.483)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79818",
    "data-name": "Path 79818",
    d: "M321.889,155a9.225,9.225,0,0,0,.93,9.728c-2.921,0-4.808,4.982-4.808,4.982s-5.7-7.929,1.591-14.267C320.011,154.8,321.889,155,321.889,155Z",
    transform: "translate(-195.995 -52.483)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79819",
    "data-name": "Path 79819",
    d: "M319.392,157.84c-.713,3.112,5.555,8.981,5.555,8.981s11.085-5.355,11.789-8.424Z",
    transform: "translate(-196.445 -52.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79820",
    "data-name": "Path 79820",
    d: "M348.123,178.79c-1.182,2.278.391,12.171,4.955,16.353.052-4.086.174-8.424.435-12.884Z",
    transform: "translate(-200.156 -55.595)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79821",
    "data-name": "Path 79821",
    d: "M334.427,137.25l-11.441,7.511c1.356,3.321,1.991,6.781-1.921,8.381a2.712,2.712,0,0,0,0,5.034,13.041,13.041,0,0,0,3.582.756,21.457,21.457,0,0,0,10.763-1.739,2.739,2.739,0,0,0,.991-4.06C333.4,148.891,333.766,141.519,334.427,137.25Z",
    transform: "translate(-196.448 -50.169)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79822",
    "data-name": "Path 79822",
    d: "M330.312,140.77l-6.772,4.443a15.194,15.194,0,0,1,.869,2.817c2.7-.156,6.233-2.3,6.3-4.529A6.389,6.389,0,0,0,330.312,140.77Z",
    transform: "translate(-196.994 -50.628)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79823",
    "data-name": "Path 79823",
    d: "M321.362,120.761c2.912-.061,3.7,4.121,2.608,5.538,2.208.478,3.278,3.06,2.608,4.347a5.414,5.414,0,0,1-5.5,2.165c-3.9-.974-4.573-4.217-3.478-5.694C315.511,125.4,316.571,120.092,321.362,120.761Z",
    transform: "translate(-196.085 -48.007)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79824",
    "data-name": "Path 79824",
    d: "M321.362,120.761c2.912-.061,3.7,4.121,2.608,5.538,2.208.478,3.278,3.06,2.608,4.347a5.414,5.414,0,0,1-5.5,2.165c-3.9-.974-4.573-4.217-3.478-5.694C315.511,125.4,316.571,120.092,321.362,120.761Z",
    transform: "translate(-196.085 -48.007)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79825",
    "data-name": "Path 79825",
    d: "M337.973,127.074c-.869,6.859-1.035,10.919-4.747,14.206-5.59,4.929-13.91,1.139-15.093-5.868-1.078-6.3.53-16.466,7.459-18.709a9.563,9.563,0,0,1,12.38,10.372Z",
    transform: "translate(-196.248 -47.426)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79826",
    "data-name": "Path 79826",
    d: "M339.277,132.894c-2.912,0-3.556-4.243-2.443-5.616-2.191-.565-3.165-3.182-2.486-4.469s3.312-2.608,5.573-1.973c3.869,1.113,4.434,4.347,3.312,5.816C345.32,128.477,344.042,133.711,339.277,132.894Z",
    transform: "translate(-198.378 -48.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79827",
    "data-name": "Path 79827",
    d: "M339.277,132.894c-2.912,0-3.556-4.243-2.443-5.616-2.191-.565-3.165-3.182-2.486-4.469s3.312-2.608,5.573-1.973c3.869,1.113,4.434,4.347,3.312,5.816C345.32,128.477,344.042,133.711,339.277,132.894Z",
    transform: "translate(-198.378 -48.003)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79828",
    "data-name": "Path 79828",
    d: "M332,129.986a2.756,2.756,0,0,1,2.1.269,5.546,5.546,0,0,1-2.1-.269Z",
    transform: "translate(-198.099 -49.207)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79829",
    "data-name": "Path 79829",
    d: "M332,130.539a2.269,2.269,0,0,1,1.782.713,4.608,4.608,0,0,1-1.782-.713Z",
    transform: "translate(-198.099 -49.292)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79830",
    "data-name": "Path 79830",
    d: "M319.326,129.376a.687.687,0,0,0-.956.27A1.3,1.3,0,0,0,319.326,129.376Z",
    transform: "translate(-196.319 -49.128)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79831",
    "data-name": "Path 79831",
    d: "M319.359,130s-.53-.078-.809.713A1.9,1.9,0,0,0,319.359,130Z",
    transform: "translate(-196.342 -49.221)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79832",
    "data-name": "Path 79832",
    d: "M342.48,136.059a6.512,6.512,0,0,1-3.669,3.025c-1.982.574-2.773-1.408-2.06-3.478.652-1.852,2.452-4.39,4.347-4.051S343.524,134.224,342.48,136.059Z",
    transform: "translate(-198.686 -49.421)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79833",
    "data-name": "Path 79833",
    d: "M330.2,129.839c0,.556-.356.991-.73.965s-.635-.5-.591-1.069.356-.991.73-.965S330.244,129.291,330.2,129.839Z",
    transform: "translate(-197.691 -49.061)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79834",
    "data-name": "Path 79834",
    d: "M326.98,141.489c-.713.139-1.365-.139-1.452-.609s.435-.956,1.148-1.1,1.365.139,1.452.609S327.676,141.358,326.98,141.489Z",
    transform: "translate(-197.252 -50.495)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79835",
    "data-name": "Path 79835",
    d: "M321.449,129.149c0,.556-.365.991-.73.965s-.643-.5-.6-1.069.365-.991.73-.965S321.484,128.584,321.449,129.149Z",
    transform: "translate(-196.546 -48.971)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79836",
    "data-name": "Path 79836",
    d: "M322.983,135.742c-4.069.278-4.851,2.26-4.138,3.13s2.452,0,2.452,0,3.295.7,4.26-.348c1.556.661,3.93-.574,3.26-1.513S326.469,135.5,322.983,135.742Z",
    transform: "translate(-196.35 -49.964)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79837",
    "data-name": "Path 79837",
    d: "M322.983,135.742c-4.069.278-4.851,2.26-4.138,3.13s2.452,0,2.452,0,3.295.7,4.26-.348c1.556.661,3.93-.574,3.26-1.513S326.469,135.5,322.983,135.742Z",
    transform: "translate(-196.35 -49.964)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79839",
    "data-name": "Path 79839",
    d: "M331.406,126.329a.417.417,0,0,0,.157-.052.33.33,0,0,0,.1-.461,3.286,3.286,0,0,0-2.608-1.556.33.33,0,1,0,0,.661h0a2.608,2.608,0,0,1,2.043,1.252.33.33,0,0,0,.313.156Z",
    transform: "translate(-197.67 -48.472)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79840",
    "data-name": "Path 79840",
    d: "M318.73,125.588a.348.348,0,0,0,.278-.148,2.608,2.608,0,0,1,2.052-1.2.33.33,0,0,0,0-.661,3.251,3.251,0,0,0-2.608,1.5.322.322,0,0,0,.1.452.287.287,0,0,0,.183.061Z",
    transform: "translate(-196.322 -48.383)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79841",
    "data-name": "Path 79841",
    d: "M328.046,300.148c1.947-31.367,1.513-63.552-1.869-70.559l-22.387-.339s2.791,52.441,3.66,73.332c.913,21.734,2.86,78.244,2.86,78.244l12.954.156S330.863,324.412,328.046,300.148Z",
    transform: "translate(-194.414 -62.186)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79842",
    "data-name": "Path 79842",
    d: "M332.116,255.65c-7.642,8.346-4.069,31.454-.739,44.182C332.29,283.914,332.534,268.065,332.116,255.65Z",
    transform: "translate(-197.52 -65.634)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79843",
    "data-name": "Path 79843",
    d: "M322.169,405.637l-11.389-.148a3.156,3.156,0,0,0-2.017.6c-3.3,2.608-5.816,2.686-9.563,3.356-4.495.809-2.269,5.329,1.043,5.381,5.477.087,5.016-.113,9.694-.043l3.234.043,1.461-1.487,1.3,1.487h5.981a1.1,1.1,0,0,0,1.113-1.208Z",
    transform: "translate(-193.484 -85.205)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79844",
    "data-name": "Path 79844",
    d: "M324.665,406.134c-.2,0-14.945-.469-14.945-.469l-.6-5.295,16.353.365Z",
    transform: "translate(-195.11 -84.537)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79845",
    "data-name": "Path 79845",
    d: "M356.708,300.186c-2.4-31.367-3.417-63.291-7.764-70.3l-26.994-.348s10.737,52.163,14.51,73.08c3.921,21.735,14.475,78.244,14.475,78.244l12.98.156S362.854,324.45,356.708,300.186Z",
    transform: "translate(-196.786 -62.224)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79846",
    "data-name": "Path 79846",
    d: "M367.7,405.637l-11.4-.148a3.147,3.147,0,0,0-2.008.6c-3.3,2.608-1.791,2.686-5.538,3.356-4.495.809-2.278,5.329,1.035,5.381,5.477.087,5.025-.113,9.694-.043l5.077.043.669-1.487.869,1.487h1.339a1.1,1.1,0,0,0,1.087-1.208Z",
    transform: "translate(-199.957 -85.205)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79847",
    "data-name": "Path 79847",
    d: "M369.449,406.129c-.209,0-15.014-.469-15.014-.469L353,400.33l16.405.365Z",
    transform: "translate(-200.842 -84.532)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79848",
    "data-name": "Path 79848",
    d: "M322.463,154.288s-3.208,5.712.478,10.346c-2.921,0-4.834,3.165-4.834,3.165s-3.886-7.824,1.86-13.041C320.367,154.167,322.463,154.288,322.463,154.288Z",
    transform: "translate(-196.116 -52.393)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79849",
    "data-name": "Path 79849",
    d: "M347.566,231.993c-15.275.635-32.793.826-43.747,0a.391.391,0,0,1-.3-.165,6.955,6.955,0,0,1-.948-4.034.409.409,0,0,1,.417-.374c14.458.391,28.829.374,43.939,0a.417.417,0,0,1,.391.252,9.077,9.077,0,0,1,.643,3.947A.4.4,0,0,1,347.566,231.993Z",
    transform: "translate(-194.252 -61.947)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79850",
    "data-name": "Path 79850",
    d: "M347.566,231.993c-15.275.635-32.793.826-43.747,0a.391.391,0,0,1-.3-.165,6.955,6.955,0,0,1-.948-4.034.409.409,0,0,1,.417-.374c14.458.391,28.829.374,43.939,0a.417.417,0,0,1,.391.252,9.077,9.077,0,0,1,.643,3.947A.4.4,0,0,1,347.566,231.993Z",
    transform: "translate(-194.252 -61.947)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79851",
    "data-name": "Path 79851",
    d: "M319.989,227.135a16.588,16.588,0,0,0,.461,5.729,68.2,68.2,0,0,0,10.111.13,33.156,33.156,0,0,0-.209-5.773C325.136,227.013,319.989,227.135,319.989,227.135Z",
    transform: "translate(-196.521 -61.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79852",
    "data-name": "Path 79852",
    d: "M353.616,166.49l.5.443.391.365.739.713c.478.469.913.939,1.356,1.417.869.948,1.7,1.93,2.478,2.921a66.726,66.726,0,0,1,4.347,6.138,78.167,78.167,0,0,1,6.546,13.249c.235.617.417.991.748,2.043a15.17,15.17,0,0,1,.556,2.608,20.089,20.089,0,0,1-.061,4.651,32.6,32.6,0,0,1-2.087,7.746,53.114,53.114,0,0,1-3.251,6.7,53.964,53.964,0,0,1-4.06,6.086,3.043,3.043,0,0,1-5.277-2.86l.052-.148a96.053,96.053,0,0,0,3.677-12.51,27.183,27.183,0,0,0,.661-5.781,8.934,8.934,0,0,0-.278-2.234,8.7,8.7,0,0,0-.869-1.887,94.954,94.954,0,0,0-6.512-11.1c-1.191-1.739-2.46-3.478-3.764-5.06-.652-.817-1.33-1.591-2-2.356l-1.008-1.1-.487-.513-.226-.235-.148-.139a6.088,6.088,0,1,1,7.99-9.189Z",
    transform: "translate(-199.606 -53.788)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79853",
    "data-name": "Path 79853",
    d: "M345.474,158.047c6.772,1.174,13.519,9.242,17.544,16.736a26.386,26.386,0,0,1-11.9,10.624S343.17,177.669,340,172,339.1,156.942,345.474,158.047Z",
    transform: "translate(-198.958 -52.873)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79854",
    "data-name": "Path 79854",
    d: "M364.389,175.34a7.894,7.894,0,0,1,1.417,2.452c-1.739,2.608-5.86,9.5-13.4,10.85a3.477,3.477,0,0,1-1.539-1.878S359.573,182.625,364.389,175.34Z",
    transform: "translate(-200.564 -55.144)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79855",
    "data-name": "Path 79855",
    d: "M340.725,157.151c-1.4-.6-.869-1.391-.869-1.391a49.7,49.7,0,0,1,10.85,1.626c.652.774-.113,1.739-.113,1.739A32.474,32.474,0,0,1,340.725,157.151Z",
    transform: "translate(-199.112 -52.586)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79856",
    "data-name": "Path 79856",
    d: "M337.707,155.553s-1.461,5.095-8.137,9.25c2.921,0,4.877,5.329,4.877,5.329s6.086-7.146,4.677-14.2C338.716,155.31,337.707,155.553,337.707,155.553Z",
    transform: "translate(-197.782 -52.553)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79857",
    "data-name": "Path 79857",
    d: "M337.516,154.5a22.8,22.8,0,0,1-7.946,10.172c2.921,0,4.947,3.156,4.947,3.156s5.981-4.973,4.608-12.024A5.877,5.877,0,0,0,337.516,154.5Z",
    transform: "translate(-197.782 -52.422)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79858",
    "data-name": "Path 79858",
    d: "M347,178.788c-.5,9.405-6.455,11.648-7.293,11.648s-6.531-2.242-6.031-11.648l6.8-2.678Z",
    transform: "translate(-201.002 -55.245)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79859",
    "data-name": "Path 79859",
    d: "M358.565,226.1l-5.355,4.608,7.1,4.616s4.347-4.764,2.191-7.477Z",
    transform: "translate(-200.869 -61.774)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79860",
    "data-name": "Path 79860",
    d: "M352.3,238.711l2.756,1.191a2.452,2.452,0,0,0,3.034-.913L360,236.016l-7.1-4.616-1.852,4.043a2.452,2.452,0,0,0,1.252,3.269Z",
    transform: "translate(-200.558 -62.466)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79861",
    "data-name": "Path 79861",
    d: "M317.316,119.13c-4.773.652-3.173,2.165,7.468,3.521s13.31.287,13.31.287S325.871,119.1,317.316,119.13Z",
    transform: "translate(-195.847 -47.802)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79862",
    "data-name": "Path 79862",
    d: "M341.643,122.835a111.4,111.4,0,0,0-24.073-5.877c-.183-2.165,1.6-4.46,1.6-4.46s-3.286-1.643-2.269-4.782,5.721-2.73,11.206-5.216c2.008,2.208,7.529,5.8,11.3,6.26.93,1.921,3.365,6.729,7.311,8.581-.061,2.1-3.982,2.608-3.982,2.608A4,4,0,0,1,341.643,122.835Z",
    transform: "translate(-196.101 -45.63)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79863",
    "data-name": "Path 79863",
    d: "M342.858,121.421c-3.417-3.1-15.553-8.772-23.56-7.451,0,0-1.782,2.3-1.6,4.46a111.4,111.4,0,0,1,24.073,5.877A4,4,0,0,0,342.858,121.421Z",
    transform: "translate(-196.229 -47.102)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79864",
    "data-name": "Path 79864",
    d: "M330.233,109.562c-1.052,5.355-4.7,6.32-5.216,6.268s-3.643-1.634-2.608-6.955l4.2-1.165Z",
    transform: "translate(-196.819 -46.31)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79865",
    "data-name": "Path 79865",
    d: "M250.491,202.523a2.173,2.173,0,0,1-2.156-1.913l-6.207-50.589a2.19,2.19,0,1,1,4.347-.53l6.173,50.615a2.165,2.165,0,0,1-1.887,2.426Z",
    transform: "translate(-186.358 -51.516)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79866",
    "data-name": "Path 79866",
    d: "M250.071,183.561c-.53-1.947.469-2.234-.5-5-.513-1.469,1.174-2.608,1.382-1.426.782,4.3,6.494,6.712,4.512,9.433S250.593,185.508,250.071,183.561Z",
    transform: "translate(-187.32 -55.314)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 49.303,
    cy: 49.303,
    r: 49.303,
    transform: "matrix(0.063, -0.998, 0.998, 0.063, 0, 98.412)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 39.818,
    cy: 39.818,
    r: 39.818,
    transform: "translate(1.45 76.518) rotate(-70.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79867",
    "data-name": "Path 79867",
    d: "M260.23,85.653c-3.269-4.416-9.563,0-11.45,4.642a12.624,12.624,0,0,0-1,3.625L245.7,79.741,244.06,66.3a4.477,4.477,0,0,0-8.885,1.087l-.409-3.347a4.472,4.472,0,0,0-8.876,1.1l.574,4.66a4.477,4.477,0,0,0-5.547-3.791h0a4.486,4.486,0,0,0-3.338,4.886l.713,5.816a4.469,4.469,0,0,0-5.547-3.79h0a4.469,4.469,0,0,0-3.33,4.877l1.426,11.624,1.017,8.337,1.348,10.945c.956,7.824,4.008,12.241,8.537,14.232,6.955,3.052,19.691,3.086,25.412-1.556,5.008-4.06,8.224-13.841,9-19.9S261.56,87.435,260.23,85.653Z",
    transform: "translate(-182.083 -40.093)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 10.302,
    height: 95.223,
    transform: "translate(77.544 11.616) rotate(38.01)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39539",
    "data-name": "Group 39539",
    transform: "translate(134.449 125.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78967_00000156546114711580636900000015945959367159725749_",
    d: "M494.683,353.9a.2.2,0,0,1,.27-.068.188.188,0,0,1,.068.068l.733,1.214.418-.691-.54-.893a.911.911,0,0,0-1.561,0l-1.875,3.1a.912.912,0,0,0,.781,1.384h1.875a.286.286,0,0,0,.254-.154h0a.924.924,0,0,1-.38-.561h-1.751a.2.2,0,0,1-.2-.2.2.2,0,0,1,.028-.1Z",
    transform: "translate(-492.065 -353.085)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78968_00000095334925852689673160000009188223499938641562_",
    d: "M520.065,356.633l-1.874-3.1a.909.909,0,0,0-.826-.44.938.938,0,0,0-.748.462l-.525.871-.418.691-1.179,2.19-.384.715h.661a.286.286,0,0,0,.254-.154h0l1.066-2.059,1.077,2.051h0a.3.3,0,0,0,.27.163h1.848a.912.912,0,0,0,.912-.913.93.93,0,0,0-.134-.473Zm-.608.568a.194.194,0,0,1-.173.1h-1.592c-.464-.86-1.186-2.19-1.186-2.19l.734-1.214a.2.2,0,0,1,.27-.068.19.19,0,0,1,.068.068l1.874,3.1A.2.2,0,0,1,519.457,357.2Z",
    transform: "translate(-511.982 -353.087)",
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39540",
    "data-name": "Group 39540",
    transform: "translate(126.815 62.983) rotate(13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78967_00000156546114711580636900000015945959367159725749_2",
    "data-name": "Path_78967_00000156546114711580636900000015945959367159725749_",
    d: "M1.6.494A.12.12,0,0,1,1.76.453.115.115,0,0,1,1.8.494l.447.74L2.5.813,2.174.269a.555.555,0,0,0-.951,0L.08,2.161A.556.556,0,0,0,.556,3H1.7a.174.174,0,0,0,.155-.094h0a.563.563,0,0,1-.232-.342H.555a.121.121,0,0,1-.121-.121.122.122,0,0,1,.017-.062Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78968_00000095334925852689673160000009188223499938641562_2",
    "data-name": "Path_78968_00000095334925852689673160000009188223499938641562_",
    d: "M3.629,2.161,2.487.269A.554.554,0,0,0,1.983,0a.572.572,0,0,0-.456.282l-.32.531-.255.421L.234,2.569,0,3H.4A.174.174,0,0,0,.558,2.91h0l.65-1.255.656,1.25h0a.186.186,0,0,0,.165.1H3.155a.555.555,0,0,0,.556-.556.566.566,0,0,0-.082-.288Zm-.371.346a.118.118,0,0,1-.105.061h-.97C1.9,2.044,1.46,1.234,1.46,1.234l.447-.74A.12.12,0,0,1,2.072.452a.116.116,0,0,1,.041.041L3.256,2.385A.119.119,0,0,1,3.258,2.507Z",
    transform: "translate(1.297 0)",
    fill: "url(#linear-gradient-18)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/AccessDenied.1447b8f83f730a878efc2fbd0e7324fa.svg";
export { ForwardRef as ReactComponent };